import React from 'react';
import PropTypes from 'prop-types';
import ErrorMsg from '../components/ErrorMsg';
import Resolution from './ResolutionParams';
import Factoring from './FactoringParams';

const Step = ({
  index,
  step,
  onChange,
  onDelete,
  onInsert,
  onUp,
  onDown,
  onRule,
  onRenaming,
  onUnifier,
  onReference1,
  onReference2,
  onBlur,
  onFocus
}) => /*#__PURE__*/React.createElement("div", {
  className: "step"
}, /*#__PURE__*/React.createElement("div", {
  className: "input-group mb-2 input-group-sm"
}, /*#__PURE__*/React.createElement("div", {
  className: "input-group-prepend"
}, /*#__PURE__*/React.createElement("span", {
  className: "input-group-text"
}, index)), /*#__PURE__*/React.createElement("input", {
  type: "text",
  name: "item",
  className: `form-control 
        ${step.formula.error ? "is-invalid" : ""}
        ${step.valid ? "is-valid" : ""}`,
  onChange: e => onChange(e.target.value),
  onBlur: e => onBlur(e.target.value),
  onFocus: e => onFocus(e.target.value),
  value: step.formula.input
}), /*#__PURE__*/React.createElement("div", {
  className: "input-group-append input-group-sm"
}, /*#__PURE__*/React.createElement("select", {
  className: "form-control",
  onChange: e => onRule(e.target.value),
  value: step.rule
}, /*#__PURE__*/React.createElement("option", null, "Assumption"), /*#__PURE__*/React.createElement("option", null, "Resolution"), /*#__PURE__*/React.createElement("option", null, "Factoring")), /*#__PURE__*/React.createElement("button", {
  type: "button",
  className: "btn btn-outline-success btn-sm",
  onClick: onInsert
}, " + "), /*#__PURE__*/React.createElement("button", {
  type: "button",
  className: "btn btn-outline-secondary btn-sm",
  onClick: onUp,
  disabled: onUp === null
}, " \u2191 "), /*#__PURE__*/React.createElement("button", {
  type: "button",
  className: "btn btn-outline-secondary btn-sm",
  onClick: onDown,
  disabled: onDown === null
}, " \u2193 "), /*#__PURE__*/React.createElement("button", {
  className: "btn btn-outline-danger",
  type: "button",
  onClick: onDelete
}, "X")), /*#__PURE__*/React.createElement(ErrorMsg, {
  error: step.formula.error,
  input: step.formula.input
})), {
  'Resolution': /*#__PURE__*/React.createElement(Resolution, {
    reference1: step.reference1,
    reference2: step.reference2,
    renaming: step.renaming,
    unifier: step.unifier,
    index: index,
    onReference1: onReference1,
    onReference2: onReference2,
    onRenaming: onRenaming,
    onUnifier: onUnifier,
    onFocus: onFocus,
    onBlur: onBlur
  }),
  'Factoring': /*#__PURE__*/React.createElement(Factoring, {
    reference: step.reference2,
    unifier: step.unifier,
    index: index,
    onReference: onReference2,
    onUnifier: onUnifier,
    onFocus: onFocus,
    onBlur: onBlur
  })
}[step.rule]);

Step.propTypes = {
  index: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onInsert: PropTypes.func.isRequired
};
export default Step;